import React, { Component, memo } from 'react'

import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IaCreators } from '../../../store/actions/intelligence'
import { BotsCreators } from '../../../store/actions/bots'
import { withTranslation } from 'react-i18next'
import { UserActions } from '../../../store/actions/users'


import IntelligenceCard from '../component/IntelligenceCard'
import IntelligenceSearch from '../component/IntelligenceSearch';
import CreateCard from '../component/CreateCard/CreateCard'
import EditIntelligenceCard from '../component/EditIntelligenceCard/EditIntelligenceCard'

// import { Container } from './styles';
import './Entidades.scss'

class Entidades extends Component {

    constructor(props) {
        super(props)
        this.state = {
            create: false,
            edit: false,
            entityEdit: '',
            filterText: ''
        }
    }

    componentDidMount() {
        if (this.props.bot.currentTokenIa !== undefined && this.props.bot.currentTokenIa !== '') {
            this.props.listIAEntities(this.props.bot.currentTokenIa);
        }
    }

    newCard = () => {
        this.setState({
            create: !this.state.create
        })
    }

    onEdit = () => {
        this.setState({
            edit: !this.state.edit
        })
    }

    deleteItem = (entity) => {
        const item = this.props.entities.find(item => item.name === entity)
        this.props.deleteEntities(this.props.bot.currentTokenIa, entity, item?.reference)
    }

    editItem = (entity) => {
        this.setState({
            entityEdit: entity,
            edit: !this.state.edit
        })
    }

    onChangeFilter =(e) =>{
        this.setState({
            filterText: e.target.value
        })
    }

    render() {
        const { create, edit, entityEdit } = this.state
        const { blt, entities, bot, user } = this.props

        return (
            <div className="cards-all">
                {create === true &&
                    <CreateCard newCard={this.newCard} />
                }
                {edit === true &&
                    <EditIntelligenceCard 
                    newCard={this.onEdit}
                    blt={blt}
                    label={entityEdit} />
                }
                {create === false && edit === false ?
                    <div>
                        <IntelligenceSearch user={user} bot={bot} blt={blt} newCard={this.newCard} onChangeFilter={this.onChangeFilter} filterText={this.state.filterText}/>

                        <div className="cards-all">
                            {bot.iaEnabled && entities.filter(card =>{
                                // return card.name.toLowerCase().indexOf(this.state.filterText.toLowerCase()) >= 0
                                return card.name.indexOf(this.state.filterText) >= 0
                            }).map(card => (
                                <IntelligenceCard 
                                    key={card._id}
                                    objects={card.objects}
                                    label={card.name}
                                    user={user}
                                    blt={blt}
                                    editItem={this.editItem}
                                    deleteItem={this.deleteItem}
                                    updatedDate={card.update} />
                            ))}
                            {bot.iaEnabled && entities.length === 0 &&
                                <p style={{ textAlign: 'center', width: '100%', marginTop: 15 }}>Nenhuma entidade criada</p>
                            }
                        </div>
                    </div> : ''}

            </div>

        );
    }
};

const mapStateToProps = state => ({
    entities: state.intelligence.entities,
    bot: state.bots.bot,
    user: state.users.signedUser,
})


const mapDispatchToProps = dispatch => bindActionCreators(
    {
        ...IaCreators,
        ...BotsCreators,
        ...UserActions,
    }, dispatch)

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(memo(Entidades))))
